import SignInButton from '@components/auth/SignInButton';
import IconMdi from '@components/IconMdi';
import InputText from '@components/InputText';
import { isPasswordSignInEnabled } from '@helpers/auth/passwordSignIn';
import { mdiChevronLeft } from '@mdi/js';

import { useRememberRedirectUrl } from '../hooks/useRememberRedirectUrl';

import { stashSsoAttempt } from './ssoAttempt';

interface Props {
  email: string;
  provider: string;
  error?: string;
  onBack: () => void;
  onSwitchToPassword: () => void;
}

const SsoStep = ({ email, provider, error, onBack, onSwitchToPassword }: Props) => {
  const { captureRedirectUrl } = useRememberRedirectUrl();

  const handleSignInClick = () => {
    stashSsoAttempt({ email, provider });
    captureRedirectUrl();
  };

  return (
    <div className="flex flex-col gap-4">
      <InputText name="email" labelText="Enter your email address" value={email} isPublic isDisabled />
      <SignInButton customProvider={provider} email={email} onClick={handleSignInClick} />
      {error && <p className="text-sm font-medium text-red-800">{error}</p>}
      {isPasswordSignInEnabled() && (
        <button
          type="button"
          className="cb--link text-primary-500 text-center text-sm font-medium"
          onClick={onSwitchToPassword}
        >
          Sign in with a password instead
        </button>
      )}
      <button
        type="button"
        className="cb--link text-info-500 flex w-fit items-center gap-1 text-sm font-medium"
        onClick={onBack}
      >
        <IconMdi path={mdiChevronLeft} size={0.7} />
        Back
      </button>
    </div>
  );
};

export default SsoStep;
